__turbopack_context__.v({
  "className": "neueheitz_23b2f70a-module__OMzFFq__className",
  "variable": "neueheitz_23b2f70a-module__OMzFFq__variable",
});
